import { UrlConstants } from "../url.constants";
export class ApiTeamConstants {
    static URL = UrlConstants.API_V2 + "Team";
    static FUNCTION_BULK_REASSIGN_TEAM_MEMBER = "BulkReassignTeamMember";
    static FUNCTION_GET_RESPONSIBLE_PERSONS = "GetResponsiblePersons";
    static FUNCTION_GET_APPLICATION_TEAM_USER_ROLES = "GetApplicationTeamUserRoles";
}
